import { html } from 'htm/preact'
import { useState, useRef, useEffect } from 'preact/hooks'
import { money, displayPrice, displayUnit } from '../units.js'

export default function IngredientPicker({ ingredients, value, onSelect }) {
  const [query, setQuery] = useState('')
  const [open, setOpen] = useState(false)
  const ref = useRef()

  const selected = ingredients.find(i => i.id === value)

  const filtered = query.trim()
    ? ingredients.filter(i => i.name.toLowerCase().includes(query.toLowerCase())).slice(0, 40)
    : ingredients.slice(0, 40)

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('click', handleClickOutside, true)
    return () => document.removeEventListener('click', handleClickOutside, true)
  }, [])

  return html`
    <div class="ingredient-picker" ref=${ref}>
      <input
        type="text"
        class="input ing-search"
        placeholder="Search ingredient…"
        value=${selected ? selected.name : query}
        onInput=${e => { setQuery(e.target.value); setOpen(true) }}
        onFocus=${() => setOpen(true)}
        autocomplete="off"
      />
      ${open && html`
        <div class="picker-dd">
          ${filtered.length === 0
            ? html`<div class="picker-dd__empty">No ingredients found</div>`
            : filtered.map(i => html`
                <button
                  type="button"
                  class="picker-dd__item"
                  onClick=${() => { onSelect(i.id, i.name, i.unit); setOpen(false); setQuery('') }}
                  key=${i.id}
                >
                  <span>${i.name}</span>
                  <small>${money(displayPrice(i.price_per_unit, i.unit))} / ${displayUnit(i.unit)}</small>
                </button>
              `)}
        </div>
      `}
    </div>
  `
}